import Vue from 'vue';

Vue.component('tax-import-modal-component', {
    props: {
        modalTriggerId: {
            type: String,
            default: 'modal-trigger',
        },
    },

    data() {
        return {
            isTaxDisclaimerModalVisible: false,

            taxDisclaimerTrigger: null,

            modalElement: null,
        };
    },

    watch: {
        isTaxDisclaimerModalVisible: {
            handler() {
                if (this.isTaxDisclaimerModalVisible) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.height = '100vh';

                    setTimeout(() => {
                        this.modalElement =
                            document.querySelector('.modal.shown');

                        this.modalElement.addEventListener(
                            'click',
                            this.handleModalVisibility,
                        );
                    }, 100);
                } else {
                    document.body.style.overflow = 'auto';
                    document.body.style.height = 'auto';

                    if (!this.modalElement) return;
                    this.modalElement.removeEventListener(
                        'click',
                        this.handleModalVisibility,
                    );
                }
            },
        },
    },

    computed: {
        toggleTaxDisclaimerModal() {
            return this.isTaxDisclaimerModalVisible ? 'shown' : '';
        },
    },

    created() {},

    mounted() {
        this.taxDisclaimerTrigger = document.getElementById(
            this.modalTriggerId,
        );

        if (!this.taxDisclaimerTrigger) return;
        this.handleCloseModalOnEsc();

        this.taxDisclaimerTrigger.addEventListener(
            'click',
            this.handleModalVisibility,
        );
        this.taxDisclaimerTrigger.style.cursor = 'pointer';
        this.taxDisclaimerTrigger.style.textDecoration = 'underline';
    },

    methods: {
        handleModalVisibility() {
            this.isTaxDisclaimerModalVisible =
                !this.isTaxDisclaimerModalVisible;
        },

        handleCloseModalOnEsc() {
            window.addEventListener('keydown', ({ key }) => {
                if (key !== 'Escape') return;
                this.isTaxDisclaimerModalVisible = false;
            });
        },
    },
});
